import { Link } from "react-router-dom";
import { priceLabel, statusBadgeClass, statusBadgeLabel } from "@/lib/data";
import { ArrowRight, MessageCircle } from "lucide-react";

export default function ForkliftCard({ f, mode }) {
  const price = priceLabel(f, mode);
  const needsRate = price === "POA" || price === "Rate on request";
  return (
    <Link to={`/forklifts/${f.slug}`} className="ff-card block group" data-testid={`forklift-card-${f.slug}`}>
      <div className="aspect-[4/3] overflow-hidden bg-[#f4f4f4] relative">
        {f.main_image && <img src={f.main_image} alt={f.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" loading="lazy" />}
        <div className="absolute top-3 left-3"><span className={statusBadgeClass(f.status)}>{statusBadgeLabel(f.status)}</span></div>
        {f.year && <div className="absolute top-3 right-3 bg-white/90 px-2 py-1 text-[11px] font-bold font-mono-tech">{f.year}</div>}
      </div>
      <div className="p-5">
        <div className="text-[11px] uppercase tracking-widest text-[#666] font-semibold">{f.brand} · {f.fuel_type}</div>
        <h3 className="font-display text-2xl font-bold mt-1 leading-tight">{f.title}</h3>
        <div className="ff-spec-row mt-4 text-xs">
          <div><div className="lbl">Capacity</div><div className="val">{f.capacity_kg ? `${f.capacity_kg} kg` : "—"}</div></div>
          <div><div className="lbl">Hours</div><div className="val font-mono-tech">{f.hours ? f.hours.toLocaleString() : "—"}</div></div>
          <div><div className="lbl">Lift</div><div className="val">{f.lift_height_mm ? `${f.lift_height_mm} mm` : "—"}</div></div>
          <div><div className="lbl">Type</div><div className="val text-base">{f.machine_type}</div></div>
        </div>
        <div className="mt-5 flex items-center justify-between gap-3">
          <div className="min-w-0">
            <div className="text-[10px] uppercase tracking-widest text-[#666] font-bold">{mode === "hire" ? "Hire" : "Sale"}</div>
            <div className="font-display text-xl font-bold text-[#D71920] truncate">{price}</div>
          </div>
          {needsRate ? (
            <span className="inline-flex items-center gap-1.5 bg-[#D71920] text-white px-3 py-1.5 text-[10px] uppercase tracking-widest font-bold whitespace-nowrap group-hover:bg-[#111] transition" data-testid={`ask-rate-${f.slug}`}>
              <MessageCircle className="w-3 h-3" /> Ask for Rate
            </span>
          ) : (
            <div className="text-xs uppercase tracking-widest font-bold flex items-center gap-1 group-hover:text-[#D71920] whitespace-nowrap">View <ArrowRight className="w-3.5 h-3.5" /></div>
          )}
        </div>
      </div>
    </Link>
  );
}
